/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BatchAnswerRequestFeedbackDTO,
  ErrorResponse,
  OpenRequestFeedbackDTO,
  RequestFeedbackDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class RequestFeedbackApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags request-feedback-api
   * @name AnswerAll
   * @summary Answer a stack of PENDING feedback markers in one transaction
   * @request POST:/api/request-feedbacks/answer
   * @secure
   */
  answerAll = (
    data: BatchAnswerRequestFeedbackDTO,
    params: RequestParams = {},
  ) =>
    this.request<RequestFeedbackDTO[], ErrorResponse | RequestFeedbackDTO[]>({
      path: `/api/request-feedbacks/answer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags request-feedback-api
   * @name GetAllOpen
   * @summary Get all still-open (PENDING) feedback markers for the current company
   * @request GET:/api/request-feedbacks/open
   * @secure
   */
  getAllOpen = (params: RequestParams = {}) =>
    this.request<OpenRequestFeedbackDTO[], ErrorResponse>({
      path: `/api/request-feedbacks/open`,
      method: "GET",
      secure: true,
      ...params,
    });
}
